import { Controller } from "stimulus"
import SlimSelect from "slim-select";
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = ['listingSelect', 'categorySelect', 'articleSelect', 'editor']

  connect() {
    this._addLinkBuildingFeatures()
  }

  _addLinkBuildingFeatures() {
    this._createSelect(this.listingSelectTarget, 'listings')
    this._createSelect(this.categorySelectTarget, 'categories')
    this._createSelect(this.articleSelectTarget, 'articles')
  }

  _createSelect(element, type) {
    let results = {};
    new SlimSelect({
      select: element,
      placeholder: "Selecione",
      searchText: "Sem resultados",
      searchPlaceholder: "Pesquisa",
      searchingText: "A pesquisar, por favor aguarde",
      ajax: function (search, callback) {
        // Perform your own ajax request here
        if (search.length <= 1) {
          callback(false)
          return
        }
        const queryString = encodeURI(`search[name]=${search}`)
        let url;
        switch (type) {
          case 'listings':
            url = "/pa/link_builder/listings.json"
            break;
          case 'categories':
            url = "/pa/link_builder/categories.json"
            break;
          case 'articles':
            url = "/pa/link_builder/articles.json"
            break;
        }

        Rails.ajax({
          type: 'GET',
          url: `${url}?${queryString}`,
          dataType: 'json',
          success: (response) => {
            const values = response.map(option => ({ value: option.id, text: option.name || option.title, url: option.url }))
            values.map(options => results[options.value] = options);
            callback(values)
          },
          error: (error) => {
            callback(false)
          }
        })
      },
      onChange: (info) => {
        let linkElement = document.createElement('a');
        // currently Trix simply removes any data attributes that we add
        // but we might need those in the future
        // this will still be here
        linkElement.dataset.id = info.value;
        linkElement.dataset.linkbuilding = true;
        linkElement.dataset.type = type;
        linkElement.href = results[info.value].url
        linkElement.innerText = info.text

        this.editorTarget.editor.insertHTML(linkElement.outerHTML);
        this.editorTarget.editorController.toolbarController.hideDialog();
        results = {};
        element.slim.close();
      }
    })
  }
}
